import { Box, Typography, useTheme } from '@mui/material'
import React, { useEffect } from 'react'
import { Dialogs, useDialogs } from '../../../sharedComponents/src/Contexts/DialogsContext'
import { useStoreActions, useStoreState } from '../../../store/hooks'
import { CountdownText } from './CountdownText'
import { CycleRewardsBar } from './CycleRewardsBar'
import { StepResult } from './StepResult'

export const StepCooldown = () => {
    const { registerDialog, unregisterDialog } = useDialogs()
    const theme = useTheme()
    const stepProgress = useStoreState((state) => state.puzzleQuestView.stepProgress)
    const cycleProgress = useStoreState((state) => state.puzzleQuestView.cycleProgress)
    const getPuzzle = useStoreActions((actions) => actions.puzzleQuestView.getPuzzle)
    const title = stepProgress.reward ? 'GREAT JOB' : 'KEEP TRYING'

    const containerRef = React.useRef<HTMLElement>(null)

    useEffect(() => {
        return () => {
            unregisterDialog(Dialogs.PUZZLE_QUEST_RESULT)
        }
    }, [])

    return (
        <Box
            ref={containerRef}
            sx={{
                padding: '0 !important',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                alignSelf: 'center',
                height: '100%',
                minHeight: { xs: 'unset', md: '620px' },
                maxHeight: { xs: '500px', md: 'unset' },
                maxWidth: { xs: '666px', md: '100%' },
                width: '100%',
                gap: { xs: '36px', md: '24px' },
                overflow: 'hidden',
                border: { xs: 'none', md: '2px solid ' + theme.palette.orange.main },
            }}
        >
            {/* Title Section */}
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    pt: { xs: '0px', md: '16px' },
                }}
            >
                <Typography
                    variant="h3"
                    sx={{
                        textAlign: 'center',
                        color: '#ffe49e',
                        textTransform: 'uppercase',
                        fontSize: { xs: '28px', md: '40px' },
                        fontWeight: 700,
                        lineHeight: 'normal',
                    }}
                >
                    {title}
                </Typography>
                <Typography
                    variant="body1"
                    sx={{
                        textAlign: 'center',
                        color: theme.palette.common.white,
                        fontSize: { xs: '24px', md: '28px' },
                        lineHeight: 'normal',
                    }}
                >
                    You earned {stepProgress.reward} crown{stepProgress.reward === 1 ? '' : 's'} today!
                </Typography>
            </Box>
            {/* Crown Animation */}
            <Box
                sx={{
                    flex: 1,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    minHeight: '200px',
                }}
            >
                <StepResult />
            </Box>
            {/* Countdown Section */}
            <CountdownText
                prefix="New puzzles available in: "
                variant="body1"
                sx={{
                    color: 'orange.main',
                    textAlign: 'center',
                    textTransform: 'capitalize',
                }}
                endTime={stepProgress.endTime}
                callback={getPuzzle}
            />
            {/* Cycle Rewards Bar */}
            {cycleProgress && (
                <Box
                    sx={{
                        pb: '16px',
                    }}
                >
                    <CycleRewardsBar
                        rewardsTotal={cycleProgress.rewardsTotal}
                        rewardsThreshold={cycleProgress.rewardsThreshold}
                        season={cycleProgress.season}
                        endTime={cycleProgress.endTime}
                        rewards={cycleProgress.rewards}
                        isCooldown={true}
                    />
                </Box>
            )}
        </Box>
    )
}
